/**
 * @generated SignedSource<<eef4651d7e80cf4441fa15650ddfab5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type entrySearchExploreKeyAnglesItemEntryContent$data = {
  readonly entityId: string;
  readonly headline: string | null | undefined;
  readonly publishedDate: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "helpersCheckIsPlusArticle" | "helpersExpertPerspectiveArticle" | "hooksContentItemProvidersContent" | "hooksPlusArticleLinkHandlerArticle">;
  readonly " $fragmentType": "entrySearchExploreKeyAnglesItemEntryContent";
};
export type entrySearchExploreKeyAnglesItemEntryContent$key = {
  readonly " $data"?: entrySearchExploreKeyAnglesItemEntryContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"entrySearchExploreKeyAnglesItemEntryContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersCheckIsPlusArticle",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaywallType",
          "kind": "LinkedField",
          "name": "paywallTypes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityUuid",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v2 = [
  (v0/*: any*/)
],
v3 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ArticleTypeSegment",
        "kind": "LinkedField",
        "name": "types",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleType",
            "kind": "LinkedField",
            "name": "value",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Article",
    "abstractKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegmentV2",
    "kind": "LinkedField",
    "name": "sectionsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v2/*: any*/),
            "type": "Section",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v2/*: any*/),
            "type": "VideoSection",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "entrySearchExploreKeyAnglesItemEntryContent",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    (v1/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersExpertPerspectiveArticle",
      "selections": (v3/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withHeadline",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withPublishedDate",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "hooksContentItemProvidersContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksPlusArticleLinkHandlerArticle",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckCanShowInPlusPlatformContent",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckArticleIsInSectionsArticle",
              "selections": (v4/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            (v1/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIsStyleArticle",
              "selections": (v4/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersGetArticleTypeArticle",
              "selections": (v3/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersUseContentSponsorContent",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Topic",
                  "kind": "LinkedField",
                  "name": "topics",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sponsor",
                      "kind": "LinkedField",
                      "name": "sponsor",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "sponsorTagSponsor"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sponsorType",
                      "storageKey": null
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "helpersCheckIsMainTopicContent",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Topic",
                      "kind": "LinkedField",
                      "name": "topics",
                      "plural": true,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "a3d9a343f0fe9771c1fe6eb5811f03a9";

export default node;
